import type React from 'react';

import { useGetDepartment } from '@vlabs/api/artemy/client';
import type { DepartmentId } from '@vlabs/api/artemy/model';
import { useGoToDepartment } from '@vlabs/monokit/features/go-to-department';
import { DeleteDepartmentsIconButton } from '@vlabs/monokit/features/point/delete-departments';
import {
  DepartmentGeneralInfo, DepartmentStreamGroupList, DepartmentListList, DepartmentPermissionTagList, DepartmentUserList,
} from '@vlabs/monokit/widgets/departments';
import { useHasPermission } from '@vlabs/permissions';

import st from './DepartmentContent.module.sass';

interface DepartmentContentProps {
  departmentId: DepartmentId;
}

function DepartmentContent({
  departmentId,
}: DepartmentContentProps): React.JSX.Element {
  const getDepartment = useGetDepartment(departmentId);
  const { goToDepartment } = useGoToDepartment();
  const canDeleteDepartment = useHasPermission('departments', 'delete');

  return (
    <div className={st.Root}>
      <div className={st.Header}>
        <h5 className={st.Title}>{getDepartment.data?.name ?? '—'}</h5>
        {!!canDeleteDepartment && (
          <DeleteDepartmentsIconButton
            departmentIds={[departmentId]}
            onDeleteDepartments={() => goToDepartment()}
          />
        )}
      </div>
      <div className={st.Content}>
        <DepartmentGeneralInfo departmentId={departmentId} />
        <DepartmentPermissionTagList departmentId={departmentId} />
        <DepartmentListList departmentId={departmentId} />
        <DepartmentUserList departmentId={departmentId} />
        <DepartmentStreamGroupList departmentId={departmentId} />
      </div>
    </div>
  );
}

export { DepartmentContent };
